import config from '@config'
import useDisableThirdPartyScripts from '@hooks/useDisableThirdPartyScripts'
import nanoid from '@utils/random'
import { CookWidget } from '@widgets/types'
import Script from 'next/script'
import {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import styled from 'styled-components'

const {
  sportbet: { scriptUrl },
} = config

interface SportbetProps {
  query: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
  theme: 0 | 1
  lang: 'de' | 'en' | 'fr' | 'it'
  animated: boolean
  scriptUrl: string
}

const StyledSportbet = styled.div``

const Sportbet: FunctionComponent<SportbetProps> = ({
  query,
  theme,
  lang,
  animated,
}) => {
  const [uniqueId, setUniqueId] = useState<string>('')
  const divRef = useRef<HTMLDivElement>(null)
  const disableThirdPartyScripts = useDisableThirdPartyScripts()

  const initializeSportbet = useCallback(() => {
    const id = divRef.current?.id
    if (!id) {
      return
    }

    try {
      new window.swisslos.SWWidget({
        target: `#${id}`,
        query,
        theme,
        lang,
        animated,
      })
    } catch (e) {
      console.error(e)
    }
  }, [divRef, query, theme, lang, animated])

  useEffect(() => {
    setUniqueId(`sportbet-${nanoid()}`)
  }, [])

  useEffect(() => {
    if (!!uniqueId && window?.swisslos?.SWWidget) {
      initializeSportbet()
    }
  }, [initializeSportbet, uniqueId])

  const handleScriptLoaded = () => {
    initializeSportbet()
  }

  if (disableThirdPartyScripts) {
    return null
  }

  return (
    <>
      <StyledSportbet ref={divRef} {...(uniqueId ? { id: uniqueId } : {})} />
      <Script
        id="sportbet-script"
        strategy="afterInteractive"
        src={scriptUrl}
        onLoad={handleScriptLoaded}
      />
    </>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'sportbet', 'inline'],
  component: Sportbet,
}

export default widget
